// Page « Équité salariale » (L05, F-600) — PLACEHOLDER trivial.
// Le vrai module d'équité (analyse comparative, écarts, plans de correction) est
// un outil du comité exécutif (L06+). Ici, une route honnête avec EmptyState —
// aucune donnée, aucune PII servie (parite ComingSoonPage : mieux qu'un item de
// nav qui redirigerait silencieusement). Cote PoC : `requireAdmin` (CE).
// ACCES (remesure 2026-09-22, E-20260914-equite-page-commentaire-perime) : l'item
// `equite` de `lib/nav/executive-nav.ts` pointe cette route depuis GC-B, reserve au
// comite executif. La garde SERVEUR existe (`server/equite/access.ts` : admin OU
// droit executif, sur /api/equite). Cette PAGE, elle, n'appelle PAS
// `canViewExecutive` : tout usager qui tape l'URL voit la coquille. Sans fuite
// aujourd'hui (aucune donnee), mais la garde de page reste a poser par le lot qui
// construit l'ecran (E-20260903-equite-page-non-gardee) — ne pas s'appuyer sur ce
// fichier pour affirmer un acces restreint.
import { PageHeader, EmptyState } from '@gs/ui';
import { Scale } from 'lucide-react';
import { useTranslation } from '../../i18n';

export default function EquiteSalarialePage() {
  const { t } = useTranslation();
  return (
    <div className="space-y-5">
      <PageHeader title={t('gest:planification.equite.title')} />
      <EmptyState
        title={t('gest:accueil.comingSoon.title')}
        description={t('gest:planification.equite.description')}
        icon={<Scale size={40} className="text-slate-300 dark:text-slate-600" aria-hidden />}
      />
    </div>
  );
}
